import styled from 'styled-components'
import { ButtonUnstyled } from '@sketch/components'
import { ReactComponent as FlagSvg } from '@sketch/icons/flag.16-svg'

/**
 * @TODO Is anything stopping us using SelectorButton here?
 */
export const ArtboardSelectorButton = styled(ButtonUnstyled)`
  min-width: 0px;
  max-width: 100%;
  display: flex;
  align-items: center;
`

export const StartPointIcon = styled(FlagSvg)`
  color: ${({ theme }) => theme.colors.foreground.secondary.D};
  width: 16px;
  height: 16px;
  flex: none;
`
